import { render } from "./Oases.vue?vue&type=template&id=94f27792"
import script from "./Oases.vue?vue&type=script&lang=js"
export * from "./Oases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/Oases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94f27792"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94f27792', __exports__)) {
    api.reload('94f27792', __exports__)
  }
  
  module.hot.accept("./Oases.vue?vue&type=template&id=94f27792", () => {
    api.rerender('94f27792', render)
  })

}


export default __exports__